(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hd-announcement"] && !Shopify.designMode) return;
  try {
    
  class HdAnnouncement extends HTMLElement {
    connectedCallback() {
      this.msgs = Array.from(this.querySelectorAll('.hd-announcement__msg'));
      if (this.msgs.length <= 1) return;
      this.index = 0;
      this.speed = (parseFloat(this.dataset.speed) || 5) * 1000;

      this.querySelectorAll('.hd-announcement__nav').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.go(btn.dataset.dir === 'next' ? 1 : -1);
          this.restart();
        });
      });
      this.start();
    }
    disconnectedCallback() { this.stop(); }
    go(step) {
      this.msgs[this.index].classList.remove('is-active');
      this.index = (this.index + step + this.msgs.length) % this.msgs.length;
      this.msgs[this.index].classList.add('is-active');
    }
    start() { this.timer = setInterval(() => this.go(1), this.speed); }
    stop() { clearInterval(this.timer); }
    restart() { this.stop(); this.start(); }
  }
  if (!customElements.get('hd-announcement')) {
    customElements.define('hd-announcement', HdAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-cardslider"] && !Shopify.designMode) return;
  try {
    
  class HdCardslider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      const step = () => {
        const card = this.track.querySelector('.hd-card');
        return card ? card.getBoundingClientRect().width + 16 : 300;
      };
      if (prev) prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
      // Videos YouTube inline : le clic remplace l'image par le player (on reste sur la page).
      this.querySelectorAll('[data-card-video]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const embed = this.embedUrl(btn.dataset.cardVideo);
          if (!embed) return;
          const holder = document.createElement('div');
          holder.className = 'hd-card__media hd-card__media--playing';
          holder.innerHTML = '<iframe src="' + embed + '" title="Video" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen playsinline webkit-playsinline></iframe>';
          btn.replaceWith(holder);
        });
      });
    }
    embedUrl(url) {
      if (!url) return '';
      let m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
      if (m) return 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1&playsinline=1&rel=0';
      m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (m) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1&playsinline=1';
      return '';
    }
  }
  if (!customElements.get('hd-cardslider')) customElements.define('hd-cardslider', HdCardslider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-cart"] && !Shopify.designMode) return;
  try {
    
  class HdCart extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.bind();
    }
    bind() {
      this.querySelectorAll('[data-line-item]').forEach((row) => {
        const key = row.dataset.key;
        const input = row.querySelector('[data-qty]');
        const dec = row.querySelector('[data-dec]');
        const inc = row.querySelector('[data-inc]');
        const remove = row.querySelector('[data-remove]');
        if (dec) dec.addEventListener('click', () => this.change(key, Math.max(0, (parseInt(input.value, 10) || 0) - 1)));
        if (inc) inc.addEventListener('click', () => this.change(key, (parseInt(input.value, 10) || 0) + 1));
        if (input) input.addEventListener('change', () => this.change(key, Math.max(0, parseInt(input.value, 10) || 0)));
        if (remove) remove.addEventListener('click', () => this.change(key, 0));
      });
      const note = this.querySelector('[data-note]');
      if (note) note.addEventListener('change', () => {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
      });
    }
    async change(key, quantity) {
      if (this.busy) return;
      this.busy = true;
      this.classList.add('is-busy');
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity, sections: this.sectionId, sections_url: '/cart' }),
        });
        const data = await res.json();
        this.updateCount(data.item_count);
        const html = data.sections && data.sections[this.sectionId];
        if (html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-cart] .hd-container');
          const mine = this.querySelector('.hd-container');
          if (fresh && mine) { mine.innerHTML = fresh.innerHTML; this.bind(); }
        } else if (data.item_count === 0) {
          window.location.reload();
        }
      } catch (e) {
        window.location.reload();
      } finally {
        this.busy = false;
        this.classList.remove('is-busy');
      }
    }
    updateCount(n) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = '(' + n + ')'; });
      document.querySelectorAll('[data-cart-badge]').forEach((el) => { el.textContent = n; el.hidden = !n; });
    }
  }
  if (!customElements.get('hd-cart')) customElements.define('hd-cart', HdCart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-header"] && !Shopify.designMode) return;
  try {
    
  class HdHeader extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.hd-header__bar');
      this.sentinel = this.querySelector('.hd-header__sentinel');
      this.burger = this.querySelector('.hd-header__burger');
      this.panel = this.querySelector('.hd-header__mobile-panel');

      this.setupSticky();
      this.setupBurger();
    }

    setupSticky() {
      if (!('IntersectionObserver' in window) || !this.sentinel) return;
      this.observer = new IntersectionObserver(
        ([entry]) => {
          const shouldStick = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (shouldStick) {
            this.style.setProperty('--hd-bar-h', `${this.bar.offsetHeight}px`);
          }
          this.classList.toggle('is-stuck', shouldStick);
        },
        { threshold: [0] }
      );
      this.observer.observe(this.sentinel);
    }

    setupBurger() {
      if (!this.burger || !this.panel) return;
      this.burger.addEventListener('click', () => {
        const open = this.classList.toggle('is-menu-open');
        this.panel.hidden = !open;
        this.burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      this.panel.querySelectorAll('a').forEach((a) => {
        a.addEventListener('click', () => {
          this.classList.remove('is-menu-open');
          this.panel.hidden = true;
          this.burger.setAttribute('aria-expanded', 'false');
        });
      });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }
  if (!customElements.get('hd-header')) {
    customElements.define('hd-header', HdHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-hero"] && !Shopify.designMode) return;
  try {
    
  class HdHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.hd-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.hd-hero__dot'));
      this.current = this.querySelector('[data-hero-current]');
      this.index = 0;
      this.speed = (parseFloat(this.dataset.autoplay) || 6) * 1000;
      if (this.slides.length <= 1) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => { this.go(parseInt(dot.dataset.goto, 10)); this.restart(); });
      });

      this.setFill();
      this.start();
    }
    disconnectedCallback() { this.stop(); }

    go(i) {
      this.slides[this.index].classList.remove('is-active');
      this.dots[this.index].classList.remove('is-active');
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides[this.index].classList.add('is-active');
      this.dots[this.index].classList.add('is-active');
      if (this.current) this.current.textContent = this.index + 1;
      this.setFill();
    }
    setFill() {
      // relance l'animation de remplissage du segment actif
      this.dots.forEach((dot, i) => {
        const fill = dot.querySelector('.hd-hero__dot-fill');
        if (!fill) return;
        fill.style.transition = 'none';
        fill.style.width = i < this.index ? '100%' : '0%';
      });
      const activeFill = this.dots[this.index] && this.dots[this.index].querySelector('.hd-hero__dot-fill');
      if (activeFill) {
        void activeFill.offsetWidth;
        activeFill.style.transition = `width ${this.speed}ms linear`;
        activeFill.style.width = '100%';
      }
    }
    start() { this.timer = setInterval(() => this.go(this.index + 1), this.speed); }
    stop() { clearInterval(this.timer); }
    restart() { this.stop(); this.start(); }
  }
  if (!customElements.get('hd-hero')) customElements.define('hd-hero', HdHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-paliers"] && !Shopify.designMode) return;
  try {
    
  class HdPaliers extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-moto]'));
      this.rows = Array.from(this.querySelectorAll('.hd-recap__row'));
      this.thresholds = this.rows.map((r) => parseInt(r.dataset.threshold, 10) || 0);
      this.labels = this.rows.map((r) => {
        const l = r.querySelector('.hd-recap__label');
        return l ? l.textContent.trim() : 'Palier';
      });
      this.feature = {
        name: this.querySelector('[data-feature-name]'),
        specs: this.querySelector('[data-feature-specs]'),
        price: this.querySelector('[data-feature-price]'),
      };
      this.track = this.querySelector('[data-feature-track]');
      this.dots = this.querySelector('[data-feature-dots]');
      this.thumbs = this.querySelector('[data-feature-thumbs]');
      this.setupFeature();

      const rendered = parseInt(this.dataset.total, 10) || 0;
      this.applyTotal(rendered);
      if (this.dataset.mode === 'auto' && this.dataset.endpoint) this.fetchAuto();
      this.setupTimer();
    }

    setupTimer() {
      const el = this.querySelector('[data-timer]');
      if (!el) return;
      const out = el.querySelector('[data-timer-count]');
      const deadline = Date.parse(el.dataset.deadline);
      if (!out || isNaN(deadline)) return;
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let s = Math.floor((deadline - Date.now()) / 1000);
        if (s <= 0) {
          out.textContent = 'Concours terminé';
          el.classList.add('is-over');
          clearInterval(this._timerInt);
          return;
        }
        const j = Math.floor(s / 86400); s -= j * 86400;
        const h = Math.floor(s / 3600); s -= h * 3600;
        const m = Math.floor(s / 60); s -= m * 60;
        out.textContent = (j > 0 ? j + ' j ' : '') + pad(h) + ' h ' + pad(m) + ' min ' + pad(s) + ' s';
      };
      tick();
      this._timerInt = setInterval(tick, 1000);
    }

    async fetchAuto() {
      try {
        const url = new URL(this.dataset.endpoint, window.location.origin);
        if (this.dataset.startDate) url.searchParams.set('since', this.dataset.startDate);
        const res = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        const data = await res.json();
        const count = Number(data.count != null ? data.count : data.orders_count);
        if (!Number.isNaN(count)) this.applyTotal(count);
      } catch (e) {}
    }

    computeState(total) {
      const thr = this.thresholds;
      let reached = 0;
      for (let i = 0; i < thr.length; i++) {
        if (total >= thr[i]) reached++;
        else break;
      }
      const prev = reached > 0 ? thr[reached - 1] : 0;
      const curr = thr[reached];
      let pct = 0;
      if (reached >= thr.length) pct = 100;
      else if (curr > prev) pct = Math.max(0, Math.min(100, Math.round(((total - prev) / (curr - prev)) * 100)));
      return { reached, pct };
    }

    applyTotal(total) {
      const { reached, pct } = this.computeState(total);
      const check = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12l5 5L20 6"/></svg>';
      const hourglass = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3h12M6 21h12M8 3v3.5a4 4 0 0 0 1.6 3.2L12 12l-2.4 2.3A4 4 0 0 0 8 17.5V21M16 3v3.5a4 4 0 0 1-1.6 3.2L12 12l2.4 2.3a4 4 0 0 1 1.6 3.2V21"/></svg>';
      this.rows.forEach((row, i) => {
        const idx = i + 1;
        const fill = row.querySelector('[data-fill]');
        const status = row.querySelector('[data-status]');
        row.classList.remove('is-reached', 'is-current', 'is-locked');
        if (idx <= reached) {
          row.classList.add('is-reached');
          if (fill) fill.style.width = '100%';
          if (status) status.innerHTML = check;
        } else if (idx === reached + 1) {
          row.classList.add('is-current');
          if (fill) fill.style.width = '100%'; // support de l'animation indeterminee (le CSS le rend transparent)
          if (status) status.innerHTML = hourglass;
        } else {
          row.classList.add('is-locked');
          if (fill) fill.style.width = '0%';
          if (status) status.textContent = '';
        }
      });
      this.cards.forEach((card) => {
        const p = parseInt(card.dataset.palier, 10) || 0;
        card.classList.toggle('is-locked', !(p > 0 && p <= reached));
      });
      const li = reached < this.labels.length ? reached : this.labels.length - 1;
      const label = this.labels[li] || 'Palier';
      const displayPct = reached >= this.thresholds.length ? 100 : pct;
      window.__hdPalierState = { label: label, pct: displayPct };
      document.dispatchEvent(new CustomEvent('hd:palier', { detail: window.__hdPalierState }));
    }
    setupFeature() {
      this.cards.forEach((card) => card.addEventListener('click', () => this.fect(card)));
      this.buildDots();
      this.buildThumbs();
      if (this.track) this.track.addEventListener('scroll', () => this.syncDots(), { passive: true });
    }
    photosOf(card) {
      try { const a = JSON.parse(card.dataset.photos || '[]'); if (a && a.length) return a; } catch (e) {}
      return card.dataset.img ? [card.dataset.img] : [];
    }
    fect(card) {
      this.cards.forEach((c) => c.classList.remove('is-featured'));
      card.classList.add('is-featured');
      const photos = this.photosOf(card);
      if (this.track) {
        const alt = (card.dataset.name || '').replace(/"/g, '&quot;');
        this.track.innerHTML = photos.length
          ? photos.map((u) => `<div class="hd-moto-feature__slide"><img src="${u}" alt="${alt}"></div>`).join('')
          : '<div class="hd-moto-feature__slide"><div class="hd-moto-feature__ph"></div></div>';
        this.track.scrollLeft = 0;
      }
      this.buildDots();
      this.buildThumbs();
      if (this.feature.name) this.feature.name.textContent = card.dataset.name || '';
      if (this.feature.specs) this.feature.specs.textContent = card.dataset.specs || '';
      if (this.feature.price) this.feature.price.textContent = card.dataset.price || '';
      // Remonte a l'image vedette pour constater le changement (ancre douce).
      const feat = this.querySelector('.hd-moto-feature');
      if (feat) feat.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    buildDots() {
      if (!this.dots || !this.track) return;
      const n = this.track.children.length;
      if (n <= 1) { this.dots.innerHTML = ''; return; }
      let html = '';
      for (let i = 0; i < n; i++) html += '<button type="button" class="hd-moto-feature__dot' + (i === 0 ? ' is-active' : '') + '" data-i="' + i + '" aria-label="Photo ' + (i + 1) + '"></button>';
      this.dots.innerHTML = html;
      this.dots.querySelectorAll('button').forEach((d) => d.addEventListener('click', () => {
        const slide = this.track.children[parseInt(d.dataset.i, 10)];
        if (slide) this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      }));
    }
    buildThumbs() {
      if (!this.thumbs || !this.track) return;
      const imgs = Array.from(this.track.querySelectorAll('img'));
      if (imgs.length <= 1) { this.thumbs.innerHTML = ''; return; }
      let html = '';
      for (let i = 0; i < imgs.length; i++) {
        html += '<button type="button" class="hd-moto-feature__thumb' + (i === 0 ? ' is-active' : '') + '" data-i="' + i + '" aria-label="Photo ' + (i + 1) + '"><img src="' + imgs[i].getAttribute('src') + '" alt="" loading="lazy"></button>';
      }
      this.thumbs.innerHTML = html;
      this.thumbs.querySelectorAll('button').forEach((t) => t.addEventListener('click', () => {
        const slide = this.track.children[parseInt(t.dataset.i, 10)];
        if (slide) this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      }));
    }
    syncDots() {
      if (!this.track || !this.track.clientWidth) return;
      const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
      if (this.dots) this.dots.querySelectorAll('button').forEach((d, di) => d.classList.toggle('is-active', di === i));
      if (this.thumbs) this.thumbs.querySelectorAll('button').forEach((t, ti) => t.classList.toggle('is-active', ti === i));
    }
  }
  if (!customElements.get('hd-paliers')) customElements.define('hd-paliers', HdPaliers);

  class HdPacks extends HTMLElement {
    connectedCallback() {
      this.packs = Array.from(this.querySelectorAll('[data-pack]'));
      this.packs.forEach((pack) => this.wire(pack));
    }
    wire(pack) {
      const chooseBtn = pack.querySelector('[data-choose]');
      const sizes = Array.from(pack.querySelectorAll('[data-size]'));
      const validate = pack.querySelector('[data-validate]');
      const dataEl = pack.querySelector('[data-variants]');
      let vdata = {};
      try { vdata = JSON.parse(dataEl.textContent); } catch (e) {}
      pack._vdata = vdata;
      const active = pack.querySelector('[data-size].is-active');
      pack._size = active ? active.dataset.size : null; // aucune taille preselectionnee : choix force
      this.updateVariant(pack);

      if (chooseBtn) chooseBtn.addEventListener('click', () => this.open(pack));
      // Toute la carte ouvre le pack (pas seulement le bouton noir).
      pack.addEventListener('click', () => {
        const panel = pack.querySelector('[data-panel]');
        if (panel && panel.hidden) this.open(pack);
      });
      sizes.forEach((b) => {
        b.addEventListener('click', () => {
          sizes.forEach((x) => x.classList.remove('is-active'));
          b.classList.add('is-active');
          pack._size = b.dataset.size;
          this.updateVariant(pack);
        });
      });
      if (validate) validate.addEventListener('click', () => this.addToCart(pack));
    }
    open(pack) {
      this.packs.forEach((p) => {
        const panel = p.querySelector('[data-panel]');
        const isTarget = p === pack;
        p.classList.toggle('is-open', isTarget);
        if (panel) panel.hidden = !isTarget;
      });
      pack.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    updateVariant(pack) {
      const validate = pack.querySelector('[data-validate]');
      if (!validate) return;
      if (!pack._size) {
        // Pas encore de taille choisie : bouton en attente (cliquable pour guider vers les tailles).
        validate.classList.add('hd-btn--locked');
        validate.dataset.variant = '';
        return;
      }
      const v = pack._vdata && pack._vdata.sizes && pack._vdata.sizes[pack._size];
      const priceEl = validate.querySelector('[data-validate-price]');
      if (v && v.id && v.available !== false) {
        validate.dataset.variant = v.id;
        validate.disabled = false;
        validate.classList.remove('hd-btn--locked');
        if (priceEl && typeof v.price === 'number') priceEl.textContent = this.money(v.price);
      } else if (v && v.available === false) {
        validate.disabled = true;
      }
    }
    money(cents) {
      try { return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); }
      catch (e) { return (cents / 100).toFixed(2) + ' EUR'; }
    }
    async addToCart(pack) {
      const validate = pack.querySelector('[data-validate]');
      const id = validate && validate.dataset.variant;
      if (!pack._size || !id) {
        // Choix de taille obligatoire : on guide vers la rangee des tailles.
        const row = pack.querySelector('.hd-pack__sizes');
        if (row) {
          row.classList.remove('is-flash');
          void row.offsetWidth;
          row.classList.add('is-flash');
          row.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      const original = validate.innerHTML;
      validate.disabled = true;
      validate.textContent = 'Ajout...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
        });
        if (!res.ok) throw new Error('add failed');
        window.location.href = this.dataset.cartUrl || '/cart';
      } catch (e) {
        validate.disabled = false;
        validate.innerHTML = original;
        alert("Ce pack n'est pas disponible pour le moment.");
      }
    }
  }
  if (!customElements.get('hd-packs')) customElements.define('hd-packs', HdPacks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-sticky"] && !Shopify.designMode) return;
  try {
    
  class HdSticky extends HTMLElement {
    connectedCallback() {
      this.gauge = this.querySelector('[data-sticky-gauge]');
      this.label = this.querySelector('[data-sticky-label]');
      this.fill = this.querySelector('[data-sticky-fill]');
      this._apply = (e) => this.apply((e && e.detail) || window.__hdPalierState);
      if (window.__hdPalierState) this.apply(window.__hdPalierState);
      document.addEventListener('hd:palier', this._apply);
      // Masque la barre quand la zone packs est a l'ecran (evite les doubles boutons).
      const packs = document.getElementById('hd-packs');
      if (packs && 'IntersectionObserver' in window && !this.classList.contains('hd-sticky--editor')) {
        this._io = new IntersectionObserver(([en]) => {
          this.classList.toggle('is-offscreen', en.isIntersecting);
        }, { threshold: 0.05 });
        this._io.observe(packs);
      }
    }
    disconnectedCallback() {
      document.removeEventListener('hd:palier', this._apply);
      if (this._io) this._io.disconnect();
    }
    apply(state) {
      // Meme fonctionnement que le recap : palier en cours + barre indeterminee (pas de %).
      if (!state || !this.gauge) return;
      this.gauge.hidden = false;
      if (this.label) this.label.textContent = state.label;
      if (this.fill) this.fill.style.width = '100%';
    }
  }
  if (!customElements.get('hd-sticky')) customElements.define('hd-sticky', HdSticky);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hd-video"] && !Shopify.designMode) return;
  try {
    
  class HdVideo extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('[data-video]');
      const btn = this.querySelector('[data-play]');
      if (btn) btn.addEventListener('click', () => this.play());
    }
    play() {
      const url = this.frame.dataset.url;
      const embed = this.embedUrl(url);
      if (!embed) return;
      this.frame.innerHTML = '<iframe class="hd-video__iframe" src="' + embed + '" title="Video" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen playsinline webkit-playsinline></iframe>';
    }
    embedUrl(url) {
      if (!url) return '';
      let m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]{11})/);
      if (m) return 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1&playsinline=1&rel=0';
      m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (m) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1&playsinline=1';
      return url;
    }
  }
  if (!customElements.get('hd-video')) customElements.define('hd-video', HdVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
